/* ********************************************************* IMPORT ********************************************************* */
// react
import React, {useEffect} from 'react';
// redux
import {connect} from 'react-redux';
import {setBackgroundColor1Action, setBackgroundColor5Action} from '../actions';
// reactstrap
import {Container} from 'reactstrap';
// window dimension hook
import {useWindowDimension} from '../hooks/useWindowDimension';

/* ********************************************************* COMPONENT ********************************************************* */
function Terms(props) {
    // width of window
    const [width] = useWindowDimension();

/* ******************************************************** BACKGROUND COLOR ********************************************************* */
    useEffect(() => {
        // set background color of nav
        props.setBackgroundColor5Action(null);
        props.setBackgroundColor1Action('color-1');
    // eslint-disable-next-line
    }, []);

/* ******************************************************** RETURN ********************************************************* */
    return (
        <Container fluid={true} className="px-5 pt-5 pb-0 mt-5">
            {width < 360 ? (
                <h1>Allgemeine Geschäfts-{'\n'}bedingungen</h1>
            ) : (
                <h1>Allgemeine Geschäftsbedingungen</h1>
            )}
            <br />
            <p>§1 Geltung gegenüber Unternehmern und Begriffsdefinitionen</p>
            (1) Die nachfolgenden Allgemeinen Geschäftbedingungen gelten für alle Lieferungen zwischen uns und einem
            Verbraucher in ihrer zum Zeitpunkt der Bestellung gültigen Fassung.
            <br />
            <br />
            Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend
            weder ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können (§ 13
            BGB).
            <br />
            <br />
            <p>§2 Zustandekommen eines Vertrages, Speicherung des Vertragstextes</p>
            (1) Die folgenden Regelungen über den Vertragsabschluss gelten für Bestellungen über unseren
            Internetshop http://www.beispielshop-online.de .<br />
            <br />
            <b>
                (2) Im Falle des Vertragsschlusses kommt der Vertrag mit
                <br />
                <div>
                    <br />
                    BeispielShop Online
                    <br />
                    Klaus Muster
                    <br />
                    Beispielstraße 42
                    <br />
                    D-98765 Musterstadt
                    <br />
                    Registernummer 12131415
                    <br />
                    Registergericht Amtsgericht Musterstadt
                    <br />
                    <br />
                </div>
                zustande.
                <br />
            </b>
            <br />
            (3) Die Präsentation der Waren in unserem Internetshop stellen kein rechtlich bindendes Vertragsangebot
            unsererseits dar, sondern sind nur eine unverbindliche Aufforderungen an den Verbraucher, Waren zu
            bestellen. Mit der Bestellung der gewünschten Ware gibt der Verbraucher ein für ihn verbindliches
            Angebot auf Abschluss eines Kaufvertrages ab.
            <br />
            (4) Bei Eingang einer Bestellung in unserem Internetshop gelten folgende Regelungen: Der Verbraucher
            gibt ein bindendes Vertragsangebot ab, indem er die in unserem Internetshop vorgesehene Bestellprozedur
            erfolgreich durchläuft.
            <br />
            <br />
            Die Bestellung erfolgt in folgenden Schritten:
            <br />
            <br />
            <div className="ml20">
                1 Auswahl der gewünschten Ware
                <br />
                2 Bestätigen durch Anklicken der Buttons „Bestellen“ <br />
                3 Prüfung der Angaben im Warenkorb
                <br />
                4 Betätigung des Buttons „zur Kasse“ <br />
                5 Anmeldung im Internetshop nach Registrierung und Eingabe der Anmelderangaben (E-Mail-Adresse und
                Passwort). <br />
                6 Nochmalige Prüfung bzw. Berichtigung der jeweiligen eingegebenen Daten.
                <br />
                7 Verbindliche Absendung der Bestellung durch Anklicken des Buttons „kostenpflichtig bestellen“ bzw.
                „kaufen“
                <br />
                <br />
            </div>
            Der Verbraucher kann vor dem verbindlichen Absenden der Bestellung durch Betätigen der in dem von ihm
            verwendeten Internet-Browser enthaltenen „Zurück“-Taste nach Kontrolle seiner Angaben wieder zu der
            Internetseite gelangen, auf der die Angaben des Kunden erfasst werden und Eingabefehler berichtigen bzw.
            durch Schließen des Internetbrowsers den Bestellvorgang abbrechen. Wir bestätigen den Eingang der
            Bestellung unmittelbar durch eine automatisch generierte E-Mail („Auftragsbestätigung“). Mit dieser
            nehmen wir Ihr Angebot an.
            <br />
            <br />
            (5) Speicherung des Vertragstextes bei Bestellungen über unseren Internetshop : Wir senden Ihnen die
            Bestelldaten und unsere AGB per E-Mail zu. Die AGB können Sie jederzeit auch unter
            http://www.beispielshop-online.de/agb.html einsehen. Ihre Bestelldaten sind aus Sicherheitsgründen nicht
            mehr über das Internet zugänglich.
            <br />
            <br />
            <p>§3 Preise, Versandkosten, Zahlung, Fälligkeit</p>
            (1) Die angegebenen Preise enthalten die gesetzliche Umsatzsteuer und sonstige Preisbestandteile. Hinzu
            kommen etwaige Versandkosten.
            <br />
            <br />
            (2) Der Verbraucher hat die Möglichkeit der Zahlung per Vorkasse, Kreditkarte( Visa ) .<br />
            <br />
            (3) Hat der Verbraucher die Zahlung per Vorkasse gewählt, so verpflichtet er sich, den Kaufpreis
            unverzüglich nach Vertragsschluss zu zahlen.
            <br />
            <br />
            <p>§4 Lieferung</p>
            (1) Sofern wir dies in der Produktbeschreibung nicht deutlich anders angegeben haben, sind alle von uns
            angebotenen Artikel sofort versandfertig. Die Lieferung erfolgt hier spätesten innerhalb von 5
            Werktagen. Dabei beginnt die Frist für die Lieferung im Falle der Zahlung per Vorkasse am Tag nach
            Zahlungsauftrag an die mit der Überweisung beauftragte Bank und bei allen anderen Zahlungsarten am Tag
            nach Vertragsschluss zu laufen. Fällt das Fristende auf einen Samstag, Sonntag oder gesetzlichen
            Feiertag am Lieferort, so endet die Frist am nächsten Werktag.
            <br />
            <br />
            (2) Die Gefahr des zufälligen Untergangs und der zufälligen Verschlechterung der verkauften Sache geht
            auch beim Versendungskauf erst mit der Übergabe der Sache an den Käufer auf diesen über. <br />
            <br />
            <p>§5 Eigentumsvorbehalt</p>
            Wir behalten uns das Eigentum an der Ware bis zur vollständigen Bezahlung des Kaufpreises vor. <br />
            <br />
            <br />
            <p>§6 Widerrufsrecht des Kunden als Verbraucher:</p>
            <b>Widerrufsrecht für Verbraucher</b>
            <br />
            <br />
            Verbrauchern steht ein Widerrufsrecht nach folgender Maßgabe zu, wobei Verbraucher jede natürliche
            Person ist, die ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch
            ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können:
            <br />
            <br />
            <p>Widerrufsbelehrung</p>
            <br />
            <b>Widerrufsrecht</b>
            <br />
            <br />
            Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.
            <br />
            <br />
            Die Widerrufsfrist beträgt vierzehn Tage, ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter,
            der nicht der Beförderer ist, die Waren in Besitz genommen haben bzw. hat.
            <br />
            <br />
            Um Ihr Widerrufsrecht auszuüben, müssen Sie uns
            <br />
            <div>
                BeispielShop Online
                <br />
                Klaus Muster
                <br />
                Beispielstraße 42
                <br />
                D-98765 Musterstadt
                <br />
                E-Mail shop@beispielshop.com
                <br />
                Telefax 05123 45678910
                <br />
            </div>
            mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief, Telefax oder E-Mail) über
            Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte
            Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
            <br />
            <br />
            <b>Widerrufsfolgen</b>
            <br />
            <br />
            Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben,
            einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie
            eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben),
            unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über
            Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe
            Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen
            wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung
            Entgelte berechnet.
            <br />
            <br />
            Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Sie den
            Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem, welches der frühere
            Zeitpunkt ist.
            <br />
            <br />
            Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen vierzehn Tagen ab dem Tag, an dem
            Sie uns über den Widerruf dieses Vertrages unterrichten, an uns zurückzusenden oder zu übergeben. Die
            Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von vierzehn Tagen absenden.
            <br />
            <br />
            Sie tragen die unmittelbaren Kosten der Rücksendung der Waren.
            <br />
            <br />
            <b>Ende der Widerrufsbelehrung</b>
            <br />
            <br />
            <p>§7 Widerrufsformular</p>
            <p>Muster-Widerrufsformular</p>
            (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es
            zurück.)
            <br />
            <br />
            <p>§8 Gewährleistung</p>
            Es gelten die gesetzlichen Gewährleistungsregelungen.
            <br />
            <br />
            <p>§9 Verhaltenskodex</p>
            Wir haben uns den Verhaltenskodizes der folgenden Einrichtungen unterworfen:
            <br />
            <p>
                Euro-Label Germany
                <br />
                EHI-EuroHandelsinstitut GmbH
                <br />
                Spichernstraße 55
                <br />
                50672 Köln
                <br />
            </p>
            Den Euro-Label Verhaltenskodex können Sie durch Anklicken des auf unserer Webseite angebrachten
            Euro-Label-Siegels oder unter http://www.euro-label.com abrufen.
            <br />
            <br />
            und <br />
            <br />
            <p>
                Trusted Shops GmbH
                <br />
                Colonius Carré
                <br />
                Subbelrather Straße 15c
                <br />
                50823 Köln
                <br />
            </p>
            Den Trusted Shops Verhaltenskodex können Sie durch Anklicken des auf unserer Webseite angebrachten
            Trusted-Shops-Siegels oder unter www.trustedshops.de abrufen.
            <br />
            <br />
            <p>§10 Vertragssprache</p>
            Als Vertragssprache steht ausschließlich Deutsch zur Verfügung.
            <br />
            <br />
            <p>§11 Kundendienst</p>
            <b>
                Unser Kundendienst für Fragen, Reklamationen und Beanstandungen steht Ihnen werktags von 9:00 Uhr
                bis 17:30 Uhr unter
                <br />
                <br />
                <p>
                    Telefon: 05123 45678911
                    <br />
                    Telefax: 05123 45678912
                    <br />
                    E-Mail: service@beispielshop.de
                    <br />
                </p>
                zur Verfügung.
            </b>
            <br />
            <br />
            <p>Stand der AGB Nov.2020</p>
            <p>
                <i>
                    <a href="http://www.agb.de">Gratis AGB</a> erstellt von agb.de
                </i>
            </p>
            <br />
            <br />
        </Container>
    );
}

/* ********************************************************* EXPORT ********************************************************* */
export default connect(null, {setBackgroundColor5Action, setBackgroundColor1Action})(Terms);
